<template>
  <div class="relative isolate mt-32 mb-32 bg-white px-6 sm:mt-56 lg:px-8">
    <div class="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl" aria-hidden="true">
      <div class="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#0AFFA9] to-[#00E091] opacity-30" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
    </div>
    <div v-motion-pop-visible-once class="mx-auto max-w-2xl text-center lg:max-w-4xl">
      <h2 class="text-base font-semibold leading-7 text-primary-600">{{ __('Pricing') }}</h2>
      <p class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">{{ __('The right price for you, whoever you are') }}</p>
    </div>
    <p v-motion-pop-visible-once class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600"></p>
    <div class="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
      <div
          v-motion
          :initial="{ x: -100, opacity: 0 }"
          :visibleOnce="{ x: 0, opacity: 1 }"
          :delay="(tierIdx+1)*150"
          v-for="(tier, tierIdx) in tiers" :key="tier.id" :class="[tier.featured ? 'relative bg-gray-900 shadow-2xl' : 'bg-white/60 sm:mx-8 lg:mx-0', tier.featured ? '' : tierIdx === 0 ? 'rounded-t-3xl sm:rounded-b-none lg:rounded-tr-none lg:rounded-bl-3xl' : 'sm:rounded-t-none lg:rounded-tr-3xl lg:rounded-bl-none', 'rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10']">
        <h3 :id="tier.id" :class="[tier.featured ? 'text-primary-400' : 'text-primary-600', 'text-base font-semibold leading-7']">{{ tier.name }}</h3>
        <p class="mt-4 flex items-baseline gap-x-2">
          <span :class="[tier.featured ? 'text-white' : 'text-gray-900', 'text-5xl font-bold tracking-tight']">{{ tier.priceMonthly }}</span>
          <span :class="[tier.featured ? 'text-gray-400' : 'text-gray-500', 'text-base']">{{ __('/month') }}</span>
        </p>
        <p :class="[tier.featured ? 'text-gray-300' : 'text-gray-600', 'mt-6 text-base leading-7']">{{ __(tier.description) }}</p>
        <ul role="list" :class="[tier.featured ? 'text-gray-300' : 'text-gray-600', 'mt-8 space-y-3 text-sm leading-6 sm:mt-10']">
          <li v-for="feature in tier.features" :key="feature" class="flex gap-x-3">
            <CheckIcon :class="[tier.featured ? 'text-primary-400' : 'text-primary-600', 'h-6 w-5 flex-none']" aria-hidden="true" />
            {{ feature }}
          </li>
        </ul>
        <inertia-link :href="route('order')" :aria-describedby="tier.id" :class="[tier.featured ? 'bg-primary-500 text-white shadow-sm hover:bg-primary-400 focus-visible:outline-primary-500' : 'text-primary-600 ring-1 ring-inset ring-primary-200 hover:ring-primary-300 focus-visible:outline-primary-600', 'mt-8 block rounded-md py-2.5 px-3.5 text-center text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10']">{{ __('Get started today') }}</inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckIcon,
} from '@heroicons/vue/solid'

export default {
  name: "PackagePricingBoxes",
  components: {
    CheckIcon,
  },
  data() {
    return {
      tiers: [
        {
          name: 'Smart',
          id: 'tier-hobby',
          href: '#',
          priceMonthly: '4,99 €',
          description: "The perfect plan if you're just getting started with our product.", // __('The perfect plan if you\'re just getting started with our product.'),
          features: [
            '10 Monitors',
            '5 Categories',
            '50 Announcements',
            // '50 Newsletter Subscribers',
            '2 Team Members',
          ],
          featured: false,
        },
        {
          name: 'Extended',
          id: 'tier-enterprise',
          href: '#',
          priceMonthly: '39,99 €',
          description: 'Excellent for businesses with many services and customers.', // __('Excellent for businesses with many services and customers.'),
          features: [
            'Unlimited Monitors',
            'Unlimited Categories',
            'Unlimited Announcements',
            'Unlimited Newsletter Subscribers',
            'Unlimited Team Members',
          ],
          featured: true,
        },
      ],
    };
  }
}
</script>